interface ArrowProps {
  className?: string;
}

export function Arrow({ className = "" }: ArrowProps) {
  return (
    <div
      className={`text-gray-400 rotate-90 md:rotate-0 self-center ${className}`}
    >
      <svg
        className="w-6 h-6 md:w-8 md:h-8"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M17 8l4 4m0 0l-4 4m4-4H3"
        />
      </svg>
    </div>
  );
}
